export default "__VITE_ASSET__BBx3pd3n__"